import { useEffect, useRef } from 'react';

import { useAtomsToastManager } from '@opendoor/atoms/toast';

export const SearchErrorToast = ({
  errorId,
  clearError,
}: {
  errorId: number | null;
  clearError: () => void;
}) => {
  const toastManager = useAtomsToastManager();
  const reportedErrorId = useRef<number | null>(null);
  useEffect(() => {
    if (errorId === null || reportedErrorId.current === errorId) {
      return;
    }
    // Adding a toast can rerun this effect before the cleared error commits.
    reportedErrorId.current = errorId;
    toastManager.add({
      title: 'We couldn’t update results. Please try again.',
      variant: 'error',
    });
    clearError();
  }, [errorId, toastManager, clearError]);
  return null;
};
